import { Block, Flex } from '@aloft/toolkit-sui';

import { ReactNode } from 'react';

export const WARNING_ICON_GUTTER_PX = 12;
export const WARNING_ICON_VALUE_GAP_PX = 2;

export function ValueWithWarningGutter({
  children,
  warning,
  valueMinWidth,
}: {
  children: ReactNode;
  warning?: ReactNode;
  valueMinWidth?: number;
}) {
  return (
    <Flex alignItems="center" gap={`${WARNING_ICON_VALUE_GAP_PX}px`} width="fit-content">
      <Block
        __dangerDoNotUseSx={{
          width: valueMinWidth !== undefined ? `${valueMinWidth}px` : undefined,
          flexShrink: 0,
        }}
      >
        {children}
      </Block>
      <Block
        width={`${WARNING_ICON_GUTTER_PX}px`}
        height={`${WARNING_ICON_GUTTER_PX}px`}
        flexShrink={0}
        __dangerDoNotUseSx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {warning}
      </Block>
    </Flex>
  );
}
